import React, { useState } from 'react';
import { changePassword } from '../../services/api';
import { Input, Btn, toast, Card } from '../../components/shared/UI';

export default function AdminSettings() {
  const [f, setF]       = useState({ currentPassword:'', newPassword:'', confirmPassword:'' });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (f.newPassword !== f.confirmPassword) { toast('Las contraseñas no coinciden', 'error'); return; }
    if (f.newPassword.length < 6) { toast('La contraseña debe tener al menos 6 caracteres', 'error'); return; }
    setLoading(true);
    try {
      await changePassword(f.currentPassword, f.newPassword, f.confirmPassword);
      toast('Contraseña actualizada correctamente ✅');
      setF({ currentPassword:'', newPassword:'', confirmPassword:'' });
    } catch (err) { toast(err.message, 'error'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ maxWidth:500 }}>
      <div style={{ marginBottom:28 }}>
        <h1 style={{ color:'#fff',fontSize:24,fontFamily:"'Syne',sans-serif",fontWeight:800,margin:'0 0 6px' }}>Configuración</h1>
        <p style={{ color:'rgba(255,255,255,0.38)',fontSize:14,margin:0 }}>Administrá tu cuenta de superadmin.</p>
      </div>

      <Card>
        <h2 style={{ color:'#fff',fontSize:15,fontWeight:600,margin:'0 0 20px' }}>🔑 Cambiar contraseña</h2>
        <form onSubmit={handleSubmit}>
          <Input label="Contraseña actual *" type="password" value={f.currentPassword} onChange={e => set('currentPassword', e.target.value)} required />
          <Input label="Nueva contraseña *"  type="password" value={f.newPassword}     onChange={e => set('newPassword', e.target.value)}     required />
          <Input label="Confirmar contraseña *" type="password" value={f.confirmPassword} onChange={e => set('confirmPassword', e.target.value)} required />
          <div style={{ display:'flex',justifyContent:'flex-end',marginTop:4 }}>
            <Btn type="submit" loading={loading}>Actualizar contraseña</Btn>
          </div>
        </form>
      </Card>
    </div>
  );
}
